import { X } from 'lucide-react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import styles from './BulkAssignToast.module.scss';

const DISMISS_MS = 8000;

const BulkAssignToast = ({ message, action, onClose }) => {
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLeaving(true), DISMISS_MS);
    return () => clearTimeout(timer);
  }, []);

  const handleAnimationEnd = () => {
    if (isLeaving) onClose();
  };

  return (
    <div className={styles.container}>
      <div
        className={`${styles.toast} ${isLeaving ? styles.toastLeaving : styles.toastEntering}`}
        onAnimationEnd={handleAnimationEnd}
      >
        <span className={styles.message}>{message}</span>
        {action && (
          <button
            type="button"
            className={styles.actionButton}
            onClick={() => {
              action.onClick();
              setIsLeaving(true);
            }}
          >
            {action.label}
          </button>
        )}
        <button
          type="button"
          className={styles.closeButton}
          aria-label="Dismiss"
          onClick={() => setIsLeaving(true)}
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

BulkAssignToast.propTypes = {
  message: PropTypes.string.isRequired,
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
};

export default BulkAssignToast;
